import { useQuery } from '@tanstack/react-query'
import client from '../api/client.js'

async function fetchStopGo({ page = 1, pageSize = 100, signal = 'all', dc = 'all', search = '' }) {
  const params = {
    page,
    page_size: pageSize,
    signal,
    dc,
  }
  if (search) params.search = search
  const { data } = await client.get('/allocation/stop-go', { params })
  return data
}

export function useAllocation({ page = 1, pageSize = 100, signal = 'all', dc = 'all', search = '' } = {}) {
  return useQuery({
    queryKey: ['allocation', 'stop-go', { page, pageSize, signal, dc, search }],
    queryFn: () => fetchStopGo({ page, pageSize, signal, dc, search }),
    staleTime: 2 * 60 * 1000,  // 2 minutes
    keepPreviousData: true,     // smooth pagination
    retry: 2,
  })
}
